/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    InlineResponse20039,
    InlineResponse20039FromJSON,
    InlineResponse20039ToJSON,
    ReadOnlyPlExciseDutyGoodsType,
    ReadOnlyPlExciseDutyGoodsTypeFromJSON,
    ReadOnlyPlExciseDutyGoodsTypeToJSON,
} from '../models';

export interface PlExciseDutyGoodsTypeListRequest {
    limit?: number;
    offset?: number;
}

export interface PlExciseDutyGoodsTypeReadRequest {
    id: string;
}

/**
 * no description
 */
export class PlExciseDutyGoodsTypeApi extends runtime.BaseAPI {

    /**
     */
    async plExciseDutyGoodsTypeListRaw(requestParameters: PlExciseDutyGoodsTypeListRequest): Promise<runtime.ApiResponse<InlineResponse20039>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/pl-excise-duty-goods-type/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => InlineResponse20039FromJSON(jsonValue));
    }

    /**
     */
    async plExciseDutyGoodsTypeList(requestParameters: PlExciseDutyGoodsTypeListRequest): Promise<InlineResponse20039> {
        const response = await this.plExciseDutyGoodsTypeListRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async plExciseDutyGoodsTypeReadRaw(requestParameters: PlExciseDutyGoodsTypeReadRequest): Promise<runtime.ApiResponse<ReadOnlyPlExciseDutyGoodsType>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling plExciseDutyGoodsTypeRead.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/pl-excise-duty-goods-type/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadOnlyPlExciseDutyGoodsTypeFromJSON(jsonValue));
    }

    /**
     */
    async plExciseDutyGoodsTypeRead(requestParameters: PlExciseDutyGoodsTypeReadRequest): Promise<ReadOnlyPlExciseDutyGoodsType> {
        const response = await this.plExciseDutyGoodsTypeReadRaw(requestParameters);
        return await response.value();
    }

}
